module.exports = __webpack_public_path__ + "img/VL_02_02.de050939.png";